/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/conquest_alt': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M21 9h-4.5v8H20v-7h1v8h-4.5v8h-1v-8H11v-8h1v7h3.5V9H11V8h10v1z"/>'
  }
})
